export const applePassEs = {
  'apple.pass.event': 'Evento',
  'apple.pass.location': 'Lugar',
  'apple.pass.date': 'Fecha',
  'apple.pass.time': 'Hora',
  'apple.pass.sector': 'Sector',
  'apple.pass.notAvailableYet':
    'El pase de Apple no está disponible todavía, inténtalo de nuevo en unos minutos.',

  'wallets.addingToAppleWallet': 'Añadiendo al Apple Wallet...',
  'wallets.addedToAppleWallet': 'Añadido al Apple Wallet',

  'wallets.addingToGoogleWallet': 'Añadiendo a Google Wallet...',
  'wallets.addedToGoogleWallet': 'Añadido a Google Wallet',
} as const;

export const applePassEn = {
  'apple.pass.event': 'Event',
  'apple.pass.location': 'Location',
  'apple.pass.date': 'Date',
  'apple.pass.time': 'Time',
  'apple.pass.sector': 'Sector',
  'apple.pass.notAvailableYet':
    'Apple pass is not available yet, try again in a few minutes.',

  'wallets.addingToAppleWallet': 'Adding to Apple Wallet...',
  'wallets.addedToAppleWallet': 'Added to Apple Wallet',

  'wallets.addingToGoogleWallet': 'Adding to Google Wallet...',
  'wallets.addedToGoogleWallet': 'Added to Google Wallet',
} as const;
